// extracted by mini-css-extract-plugin
export default {"control":"control_control__hJ2T+","button":"control_button__doeFs"};